// Import the functions you need from the SDKs you need
import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration - MADERERÍA LA HUERTA
const firebaseConfig = {
  apiKey: "AIzaSyD-DLWzW_qvAYW03i0CZpj3rTGHYwA9O5E",
  authDomain: "madereria2025-e1e26.firebaseapp.com",
  databaseURL: "https://madereria2025-e1e26-default-rtdb.firebaseio.com",
  projectId: "madereria2025-e1e26",
  storageBucket: "madereria2025-e1e26.firebasestorage.app",
  messagingSenderId: "883026342740",
  appId: "1:883026342740:web:466b1989ca30fe518a0ec1"
};

// Initialize Firebase only if it hasn't been initialized already
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);

export default app;
